import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const solutionCategories = ['Deactivation', 'Tuning', 'Miscellaneous'];

const SolutionCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    name: '',
    code: '',
    category: solutionCategories[0],
    description: '',
  });

  const handleChange = (field: keyof typeof formState) =>
    (event: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => {
      setFormState(prev => ({
        ...prev,
        [field]: event.target.value,
      }));
    };

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }}>
        <Box>
          <Typography variant="h4" component="h1" fontWeight={600} gutterBottom>
            Create solution
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Define a new solution that can be offered during file service requests.
          </Typography>
        </Box>
        <Button variant="outlined" onClick={() => navigate('/solutions')}>
          Back to solutions
        </Button>
      </Stack>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Stack spacing={3}>
            <TextField
              label="Solution name"
              value={formState.name}
              onChange={handleChange('name')}
              fullWidth
            />
            <TextField
              label="Code"
              value={formState.code}
              onChange={handleChange('code')}
              helperText="Short identifier, e.g. STAGE1"
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                label="Category"
                value={formState.category}
                onChange={handleChange('category') as any}
              >
                {solutionCategories.map(category => (
                  <MenuItem value={category} key={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Description"
              value={formState.description}
              onChange={handleChange('description')}
              multiline
              minRows={3}
              fullWidth
            />

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="outlined" onClick={() => navigate('/solutions')}>
                Cancel
              </Button>
              <Button variant="contained" disabled>
                Save (coming soon)
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SolutionCreatePage;

